import { createStore } from '@rehaje/core'

import {
  onFormInput,
  onFormSubmit,
  onFormValidate,
  onFormValueChange
} from '../events'
import { FormPlugin } from '../plugin'

import type {
  FormInputEvent,
  FormSubmitEvent,
  FormValidateEvent,
  FormValueChangeEvent
} from '../events'
import type { FormPluginProps, SchemaMessages } from '../types'
import type { Store, StoreOptions, TypedSpecific } from '@rehaje/core'

export interface CreateFormProps extends FormPluginProps, StoreOptions {
  /**
   * 表单值变化事件
   * @param value
   */
  onChange?: (value: any, event: FormValueChangeEvent) => void

  /**
   * 输入控件输入时触发事件
   * @param value
   */
  onInput?: (value: any, event: FormInputEvent) => void
  /**
   * 表单提交事件
   * @param value
   */
  onSubmit?: (value: any, event: FormSubmitEvent) => Promise<any>

  /**
   * 表单校验事件
   * @param errors
   */
  onValidate?: (
    errors: SchemaMessages[],
    event: FormValidateEvent
  ) => Promise<any>
}

export const createForm = <T extends TypedSpecific>(
  specific: T,
  props?: CreateFormProps
): Store<T> => {
  return createStore(specific, {
    ...props,
    effects(store) {
      props?.effects?.(store)
      if (props?.onChange) {
        onFormValueChange((event) => {
          if (!store.isInitialized()) return
          const model = event.target?.model
          const form = model?.form
          props.onChange?.(form?.value, event)
        })
      }
      if (props?.onInput) {
        onFormInput((event) => {
          const model = event.target?.model
          const form = model?.form
          props.onInput?.(form?.value, event)
        })
      }
      if (props?.onSubmit) {
        onFormSubmit((event) => {
          const model = event.target?.model
          const form = model?.form
          event.preventDefault()
          form
            ?.__r_submit((value) => props.onSubmit?.(value, event))
            .finally(() => {
              form.submitting = false
            })
        })
      }
      if (props?.onValidate) {
        onFormValidate((event) => {
          props.onValidate?.(event.detail ?? [], event)
        })
      }
    },
    plugins: [new FormPlugin(props), ...(props?.plugins ?? [])]
  })
}
